import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {TagSchema} from 'constants/RegistryConstants';
import SchemaSelector, {SchemaSelectorBaseProps, SchemaSelectorSchema} from 'samples/SchemaSelector';
import {getSchemaSearchableMenuOptionDatas, Section} from 'samples/SchemaStarsUtil';
import {getRenderStarredOptionContent} from 'util/getRenderStarredOptionContent';

export interface BaseStarsAwareSchemaSelectorProps {
  starredSchemaIds: Array<string> | null;
  onToggleStar: (schemaId: string) => void;

  isSchemaDisabledFn?: (tagSchema: TagSchema) => boolean;

  // Value to add to the schema when it's disabled explaining why
  disabledMessage?: string;
  sections?: Array<Section>;
  getSchemaOwner: (schema: {id: string; name: string}) => string | undefined;
  /** When provided, each schema option shows this as grey subtext below the schema name. */
  getSchemaMetadata?: (schema: {id: string}) => string | undefined;
}

export type StarsAwareSchemaSelectorProps = SchemaSelectorBaseProps &
  BaseStarsAwareSchemaSelectorProps & {
    shouldShowNoSchemaOption: boolean;
  };

export default class StarsAwareSchemaSelector extends React.Component<StarsAwareSchemaSelectorProps> {
  static defaultProps = {
    isDisabled: false,
    shouldShowNoSchemaOption: false,
    isSchemaDisabledFn: (): false => false,
    disabledMessage: '',
  };

  private handleChange = (schema: SchemaSelectorSchema): void => {
    if (schema.id == null) {
      this.props.onChange(null);
    } else {
      this.props.onChange(schema);
    }
  };

  override render(): JSX.Element {
    const dataTestAttrs = {component: 'SchemaSelector', element: 'starredOptionContent'};

    return (
      <SchemaSelector
        error={this.props.error}
        isDisabled={this.props.isDisabled}
        placeholder={this.props.placeholder}
        onChange={this.handleChange}
        menuOptionDatas={getSchemaSearchableMenuOptionDatas(this.props.schemas, this.props.starredSchemaIds, {
          shouldShowNoSchemaOption: this.props.shouldShowNoSchemaOption,
          isSchemaDisabledFn: this.props.isSchemaDisabledFn,
          disabledMessage: this.props.disabledMessage,
          sections: this.props.sections,
          getSchemaOwner: this.props.getSchemaOwner,
          getSchemaMetadata: this.props.getSchemaMetadata,
        })}
        menuRender={getRenderStarredOptionContent(
          this.props.onToggleStar,
          this.props.starredSchemaIds,
          {},
          css(styles.optionItem),
          dataTestAttrs
        )}
        schemas={this.props.schemas}
        selectedSchemaId={this.props.selectedSchemaId}
        itemContainerClassName={css(styles.optionItemContainer)}
        shouldDefaultIfSingleItem={this.props.shouldDefaultIfSingleItem}
        dataTestAttrs={this.props.dataTestAttrs}
      />
    );
  }
}

const styles = StyleSheet.create({
  optionItem: {
    paddingTop: 8,
    paddingBottom: 8,
  },
  optionItemContainer: {
    minHeight: 20,
    height: 'auto',
  },
});
